import React from 'react';
import Navbar from './Navbar';
import { Route, Routes } from 'react-router-dom';
import Dashboard from '../../Pages/Dashboard/Dashboard';
import Footer from './Footer';
import AllProperties from '../../Pages/Dashboard/AllProperties';
import Viewproperty from '../../Pages/Dashboard/Viewproperty';
import Listing from '../../Pages/Dashboard/Listing';
import Wallet from '../../Pages/Dashboard/Wallet';
import Setting from '../../Pages/Dashboard/Setting';
import ListerDashboard from '../../Pages/Dashboard/Lister/Dashboard';
import ListerPortfolio from '../../Pages/Dashboard/Lister/Portfolio';
import AddProperty from '../../Pages/Dashboard/AddProperty';
import MyProperties from '../../Pages/Dashboard/MyProperties';
import Sidebar from './SideBar';
import ViewOwnProperty from '../../Pages/Dashboard/viewOwnProperty';

function Layout() {
  const state = {
    userType: 'liste',
  };
  return (
    <div className='relative h-screen flex'>
        <div className={'lg:w-[15%] lg:block hidden'}>
            <Sidebar />
        </div>
        <div className={'lg:w-[85%] w-full overflow-y-auto flex flex-col'}>
            <Navbar />
            <div className='bg-custom-white overflow-y-auto flex-1'>

                {/*<div className={'bg-red-500 text-white text-sm w-fit mx-auto py-3 px-5 rounded-2xl my-4'}>*/}
                {/*    Please click <span className={'underline font-semibold'}>here</span> to complete your kyc to have*/}
                {/*    access to the other section*/}
                {/*</div>*/}

                <Routes>
                    <Route path='/dashboard' element={state.userType === 'lister' ? <ListerDashboard/> : <Dashboard />} />
                    <Route path='/properties' element={state.userType === 'lister' ? <ListerPortfolio/> : <AllProperties />} />
                    <Route path='/myproperties' element={state.userType === 'lister' ? <ListerPortfolio/> : <MyProperties />} />
                    <Route path='/properties/:id' element={<Viewproperty />} />

                    <Route path='/myproperties/:id' element={<ViewOwnProperty/>}/>

                    <Route path='/listing' element={<Listing />} />
                    <Route path='/wallet' element={<Wallet />} />
                    <Route path='/setting' element={<Setting />} />
                    <Route path='/addproperty' element={<AddProperty />} />
                </Routes>
            </div>
            <Footer />
        </div>
    </div>
  );
}

export default Layout;
